module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (63).a4b99082.jpg";